function updateBoldPricing(products) {
  for (var n = 0; n < products.length; n++) {
    BOLD.helpers.getProduct(products[n].handle, function(prod) {
      var price = document.getElementsByClassName('product-' + prod.id);
      if (price.length) {
        price = price[0].getElementsByClassName('money')[0];
      } else {
        price = document.querySelector('a[href*="' + prod.handle + '"]').querySelector('.bc-sf-filter-product-item-regular-price');
      }
      if (!price) {
      	price = document.querySelector('.productitem#' + prod.handle).querySelector('.money');
      }
      price.classList += " bold_price";
      if (BOLD && BOLD.common) {
        var formatMoney = Shopify.formatMoney || BOLD.common.Shopify.formatMoney;
        price.textContent = formatMoney(prod.price_min, Shopify.money_format || window.BOLD.common.Shopify.shop.money_format);
      }
try {document.getElementById(prod.handle).querySelector('[data-quick-buy]').setAttribute('data-pop-price', prod.price);}catch(err){}
    });
  }
}
function renderDiscountIcons(products) {
  for (var i = 0; i < products.length; i++) {
  	var ele = document.querySelector('a[href*="' + products[i].handle + '"]');
    var xhr = new XMLHttpRequest()
    xhr.addEventListener('load', function(res) {
      var img = document.createRange().createContextualFragment(res.target.response);
      this.prepend(img);
    }.bind(ele))
    xhr.open('GET', '/products/' + products[i].handle + '?view=bold_discount');
    xhr.send();
  }
}
var bold_BCSfFilterCallback = BCSfFilterCallback;
BCSfFilterCallback  = function(res) {
  for (var i = 0; i < res.products.length; i++) {
    if (res.products[i].product_type === "OPTIONS_HIDDEN_PRODUCT"  || res.products[i].product_type === "DISCOUNT_HIDDEN_PRODUCT" || res.products[i].tags.indexOf('DISCOUNT_HIDDEN_PRODUCT') !== -1 ) {
      res.products.splice(i, 1);
    }
  }
  bold_BCSfFilterCallback(res);
  // Uncomment line below to render discount icons (Product Discount App only!)
  renderDiscountIcons(res.products);
  if (BOLD && BOLD.csp) {
    updateBoldPricing(res.products);
  }
  if (window.BOLD && BOLD.common && BOLD.common.eventEmitter &&
    typeof BOLD.common.eventEmitter.emit === 'function'){
  BOLD.common.eventEmitter.emit('BOLD_CURRENCY_double_check');
}
}
